import React from "react";

const AdditionalSettingsSection = ({ formData, handleInputChange }) => {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold mb-4 pb-2 border-b">
        Additional Settings
      </h3>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block mb-1 font-medium">Grace Period (Days)</label>
          <input
            type="number"
            name="gracePeriodDays"
            value={formData.gracePeriodDays || ""}
            onChange={handleInputChange}
            min="0"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Trial Duration (Days)</label>
          <input
            type="number"
            name="trialDurationDays"
            value={formData.trialDurationDays || ""}
            onChange={handleInputChange}
            min="0"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Earn to Pay Method</label>
          <select
            name="earnToPayMethod"
            value={formData.earnToPayMethod || "FlatRate"}
            onChange={handleInputChange}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="FlatRate">Flat Rate</option>
            <option value="Percentage">Percentage</option>
          </select>
        </div>

        <div>
          <label className="block mb-1 font-medium">Earn to Pay Amount</label>
          <input
            type="number"
            name="earnToPayAmount"
            value={formData.earnToPayAmount || ""}
            onChange={handleInputChange}
            min="0"
            step="0.01"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex items-center">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="isActive"
              checked={formData.isActive || false}
              onChange={handleInputChange}
              className="rounded text-blue-600 focus:ring-blue-500"
            />
            <span className="font-medium">Active Plan</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default AdditionalSettingsSection;